import { Text } from '@betterment/samba-react';
import { Box, Flex, Tag } from '@betterment/style-closet-react';
import { format as formatDate, parseISO as parseDate } from 'date-fns';

import { SenderOfferFulfillment as Props } from '../data';

type TagColors = 'bmtTeal10' | 'bmtGold10' | 'bmtBlue10';

function getStatusColor(statusString: string): TagColors {
  switch (statusString) {
    case 'Active':
      return 'bmtTeal10';
    case 'Expired':
    case 'Pending':
      return 'bmtGold10';
    default:
      return 'bmtBlue10';
  }
}

function getRewardCopy(displayReward: string, rewardType: string): string {
  switch (rewardType) {
    case 'savings_rate_boost':
      return `You've unlocked a ${displayReward} boost on your Cash Reserve`;
    case 'free_dollars_fixed':
      return `You've earned ${displayReward} managed free on your investment balance`;
    case 'free_time':
      return `You've earned ${displayReward} of your investment balance managed free`;
    default:
      throw new Error('Unknown reward type');
  }
}

function getSubheaderCopy(statusString: string, startDate: string, endDate: string): string {
  switch (statusString) {
    case 'Pending':
      return 'Your reward will be active soon';
    default:
      return `${formatDate(parseDate(startDate), 'M/d/yyyy')} - ${formatDate(parseDate(endDate), 'M/d/yyyy')}`;
  }
}

const ClaimedRewardItem: React.FC<Props> = ({ startDate, endDate, status, displayReward, rewardType }) => {
  return (
    <Box>
      <Text
        as="p"
        css={{
          marginBottom: 'space.100',
        }}
      >
        {getRewardCopy(displayReward, rewardType)}
      </Text>
      <Flex alignItems="center">
        <Tag size="small" bg={getStatusColor(status)} px="3">
          {status}
        </Tag>
        <Text
          as="p"
          color="text.weak"
          css={{
            marginBottom: 'space.0',
            paddingLeft: 'space.100',
          }}
        >
          {getSubheaderCopy(status, startDate, endDate)}
        </Text>
      </Flex>
    </Box>
  );
};

export default ClaimedRewardItem;
